import SectionHeading from "@/components/base/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

type FaqSectionProps = {
  kicker?: string;
  title?: string;
  desc?: string;
  limit?: number;
};

export default function FaqSection({
  kicker = "常见问题",
  title = "关于追踪，你可能想先搞清楚这几件事",
  desc = "我们把读者问得最多的疑问整理在这里。如果还有没被回答的，欢迎随时把问题发到编辑部邮箱。",
  limit,
}: FaqSectionProps) {
  const items = typeof limit === "number" ? faqs.slice(0, limit) : faqs;

  return (
    <section className="bg-background-100 py-12 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading kicker={kicker} title={title} desc={desc} />
            <div className="hidden rounded-lg border border-background-300 bg-background-50 p-5 lg:block">
              <span className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                <i className="ri-question-answer-line text-xl" />
              </span>
              <p className="text-sm leading-relaxed text-foreground-600">
                还有别的疑问？发送邮件到编辑部，我们会在整理后补充进这里。
              </p>
            </div>
          </div>
          <div className="lg:col-span-8">
            <FaqAccordion items={items} />
          </div>
        </div>
      </div>
    </section>
  );
}